module.exports = "<div class=\"recommended_content_search\"><input class=\"lpview_search text_input_field\" type=\"text\" placeholder=\"{{search}}\"/></div>";